module.exports = __webpack_public_path__ + "static/media/icon_menu.0da73329.svg";